import React from 'react';
import ArrowLeft from '@wix/da-ds/pkg/Icons/24x24/ArrowLeft';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import s from './BackButton.scss';
const BackButton = ({ currentDuperbrowseItem, exitDuperbrowse })=>{
    const onClick = ()=>{
        exitDuperbrowse && exitDuperbrowse();
    };
    return /*#__PURE__*/ React.createElement(IconButton, {
        className: s['root'],
        onClick: onClick,
        biData: BiData({
            evid: 304,
            link_url: currentDuperbrowseItem === null || currentDuperbrowseItem === void 0 ? void 0 : currentDuperbrowseItem.url,
            itemid: currentDuperbrowseItem === null || currentDuperbrowseItem === void 0 ? void 0 : currentDuperbrowseItem.deviationId,
            typeid: currentDuperbrowseItem === null || currentDuperbrowseItem === void 0 ? void 0 : currentDuperbrowseItem.typeId
        }),
        size: "small",
        icon: ArrowLeft
    });
};
BackButton.displayName = 'BackButton';
export default BackButton;
